import { render, staticRenderFns } from "./ArtistByCategory.vue?vue&type=template&id=345041ee"
import script from "./ArtistByCategory.vue?vue&type=script&lang=js"
export * from "./ArtistByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports